export default __webpack_public_path__ + "static/media/Graphic-Assets4.aa544668.jpg";